import React from "react";
import { useForm } from "react-hook-form";
import { Form, Button } from "react-bootstrap";
import "../styles/ContactForm.css";

export default function ContactForm() {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();
	const onSubmit = (data) => console.log(data);
	console.log(errors);

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<Form.Group className="mb-3" controlId="formBasicEmail">
				<Form.Label>Email address</Form.Label>
				<Form.Control
					type="email"
					placeholder="Enter email"
					{...register("Email", { required: true, pattern: /^\S+@\S+$/i })}
				/>
				<Form.Text className="text-muted">
					We'll never share your email with anyone else.
				</Form.Text>
			</Form.Group>

			<Form.Group className="mb-3" controlId="formBasicText">
				<Form.Label>Question</Form.Label>
				<Form.Control
					type="text"
					placeholder="Question or Query"
					{...register("Question", { required: true })}
				/>
			</Form.Group>
			<Button variant="primary" type="submit">
				Submit
			</Button>
		</Form>
	);
}
